import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography,
} from '@mui/material';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { QR_DISPLAY_TEMPLATE } from '../constants/qrDisplay';

export default function ConfigQrPrintPanel({
  printRef,
  qrDataUrl,
  qrLoading = false,
  hasQrCode = false,
  onDownloadPng,
  onDownloadPdf,
  onPrintCard,
}) {
  return (
    <Paper variant="outlined" sx={{ p: 3, mb: 4, borderRadius: 3 }}>
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <QrCode2Icon color="primary" />
        <Box>
          <Typography variant="subtitle1" fontWeight="bold">
            Material impresso para mesas
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Use este material para imprimir e colocar nas mesas ou balcão.
          </Typography>
        </Box>
      </Box>
      <Paper variant="outlined" sx={{ p: 2, bgcolor: '#f9fafb' }}>
        <Box
          ref={printRef}
          sx={{
            position: 'relative',
            width: '100%',
            maxWidth: 520,
            mx: 'auto',
            lineHeight: 0,
            backgroundColor: '#fff',
          }}
        >
          <Box
            component="img"
            src={QR_DISPLAY_TEMPLATE.backgroundUrl}
            alt="Modelo de display com QR Code"
            crossOrigin="anonymous"
            sx={{ width: '100%', height: 'auto', display: 'block' }}
          />
          {QR_DISPLAY_TEMPLATE.placements.map((placement, index) => (
            <Box
              key={`${placement.left}-${placement.top}-${index}`}
              sx={{
                position: 'absolute',
                left: placement.left,
                top: placement.top,
                width: QR_DISPLAY_TEMPLATE.size.width,
                height: QR_DISPLAY_TEMPLATE.size.height,
                transform: `translate(-50%, -50%) rotate(${QR_DISPLAY_TEMPLATE.rotation})`,
                transformOrigin: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#fff',
                borderRadius: 0.5,
                boxShadow: hasQrCode ? 'none' : 'inset 0 0 0 1px rgba(0, 0, 0, 0.12)',
                overflow: 'hidden',
              }}
            >
              {qrLoading ? (
                <CircularProgress size={20} />
              ) : hasQrCode ? (
                <Box
                  component="img"
                  src={qrDataUrl}
                  alt="QR Code de check-in"
                  crossOrigin="anonymous"
                  sx={{ width: '100%', height: '100%', display: 'block', objectFit: 'contain' }}
                />
              ) : (
                <Typography variant="caption" color="text.secondary">
                  QR indisponível
                </Typography>
              )}
            </Box>
          ))}
        </Box>
      </Paper>
      <Box display="flex" alignItems="center" gap={1} mt={2} flexWrap="wrap">
        <Button variant="outlined" onClick={onDownloadPng} disabled={!hasQrCode}>
          Baixar PNG
        </Button>
        <Button variant="outlined" onClick={onDownloadPdf} disabled={!hasQrCode}>
          Baixar PDF
        </Button>
        <Button variant="contained" onClick={onPrintCard} disabled={!hasQrCode}>
          Imprimir
        </Button>
        <Typography variant="caption" color="text.secondary">
          Recomendado: PDF para gráfica.
        </Typography>
      </Box>
    </Paper>
  );
}
